import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=7c0393ad&scoped=true&"
import script from "./Number.vue?vue&type=script&lang=js&"
export * from "./Number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0393ad",
  null
  
)

export default component.exports